module.exports = __webpack_public_path__ + "34bc775d/img/share-icon.0f8a11b4.svg";